import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  useTheme,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
import { useAppSelector } from '../../../../../../hooks';
import { getCourseStudentsState } from '../../../../../../store/V2/CourseStudentsSlice';
import { IUser } from '../../../../../../store/UserSlice';
import BasicLoader from '../../../../../../components/Loaders/BasicLoader';

interface SelectStudentModalProps {
  open: boolean;
  onClose: () => void;
  onSelect: (student: IUser) => void;
}

const SelectStudentModal: React.FC<SelectStudentModalProps> = ({
  open,
  onClose,
  onSelect,
}) => {
  const theme = useTheme();

  // Store

  const { adminCourseStudentsData, status } = useAppSelector(
    getCourseStudentsState
  );

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      open={open}
      PaperProps={{
        sx: {
          borderRadius: '20px',
          padding: 0,
        },
      }}
    >
      <DialogTitle>Select a Student</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: { xs: '7px', sm: '16px' },
          top: { xs: '7px', sm: '12px' },
        }}
      >
        <CloseIcon sx={{ color: '#000000' }} />
      </IconButton>
      <DialogContent sx={{ pt: `${theme.spacing(2)} !important` }}>
        <Grid container spacing={2}>
          {adminCourseStudentsData &&
          adminCourseStudentsData.list &&
          adminCourseStudentsData.list.length ? (
            <Grid item xs={12}>
              <List disablePadding>
                {adminCourseStudentsData.list.map((item, index) => {
                  const { student } = item;

                  const studentName = student
                    ? `${student.firstname} ${student.lastname || ''}`
                    : '';

                  return [
                    <ListItem key={`li-${index}`} disablePadding>
                      <ListItemButton onClick={() => onSelect(student)}>
                        <ListItemText
                          title={studentName}
                          className="ellipsis-text one-line"
                          primary={studentName}
                        />
                      </ListItemButton>
                    </ListItem>,
                    <Divider key={`li-divider-${index}`} />,
                  ];
                })}
              </List>
            </Grid>
          ) : null}

          <Grid item xs={12}>
            <BasicLoader
              loaderProps={{ size: 20 }}
              containerProps={{
                visibility: status === 'loading' ? undefined : 'hidden',
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default SelectStudentModal;
